var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLists(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "#2352C1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.10914 2.66691C2.83213 2.66691 3.41824 2.06991 3.41824 1.33346C3.41824 0.597009 2.83213 0 2.10914 0C1.38615 0 0.800049 0.597009 0.800049 1.33346C0.800049 2.06991 1.38615 2.66691 2.10914 2.66691Z",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8909 0H6.03639C5.6892 0 5.35622 0.140489 5.11072 0.39056C4.86522 0.640632 4.72729 0.979802 4.72729 1.33346C4.72729 1.68711 4.86522 2.02628 5.11072 2.27635C5.35622 2.52643 5.6892 2.66691 6.03639 2.66691H13.8909C14.2381 2.66691 14.5711 2.52643 14.8166 2.27635C15.0621 2.02628 15.2 1.68711 15.2 1.33346C15.2 0.979802 15.0621 0.640632 14.8166 0.39056C14.5711 0.140489 14.2381 0 13.8909 0Z",
    strokeWidth: 0
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10914 7.33488C2.83213 7.33488 3.41824 6.73787 3.41824 6.00143C3.41824 5.26498 2.83213 4.66797 2.10914 4.66797C1.38615 4.66797 0.800049 5.26498 0.800049 6.00143C0.800049 6.73787 1.38615 7.33488 2.10914 7.33488Z",
    strokeWidth: 0
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8909 4.66797H6.03639C5.6892 4.66797 5.35622 4.80846 5.11072 5.05853C4.86522 5.3086 4.72729 5.64777 4.72729 6.00143C4.72729 6.35508 4.86522 6.69425 5.11072 6.94432C5.35622 7.19439 5.6892 7.33488 6.03639 7.33488H13.8909C14.2381 7.33488 14.5711 7.19439 14.8166 6.94432C15.0621 6.69425 15.2 6.35508 15.2 6.00143C15.2 5.64777 15.0621 5.3086 14.8166 5.05853C14.5711 4.80846 14.2381 4.66797 13.8909 4.66797Z",
    strokeWidth: 0
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.10914 11.9999C2.83213 11.9999 3.41824 11.4029 3.41824 10.6665C3.41824 9.93002 2.83213 9.33301 2.10914 9.33301C1.38615 9.33301 0.800049 9.93002 0.800049 10.6665C0.800049 11.4029 1.38615 11.9999 2.10914 11.9999Z",
    strokeWidth: 0
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8909 9.33301H6.03639C5.6892 9.33301 5.35622 9.4735 5.11072 9.72357C4.86522 9.97364 4.72729 10.3128 4.72729 10.6665C4.72729 11.0201 4.86522 11.3593 5.11072 11.6094C5.35622 11.8594 5.6892 11.9999 6.03639 11.9999H13.8909C14.2381 11.9999 14.5711 11.8594 14.8166 11.6094C15.0621 11.3593 15.2 11.0201 15.2 10.6665C15.2 10.3128 15.0621 9.97364 14.8166 9.72357C14.5711 9.4735 14.2381 9.33301 13.8909 9.33301Z",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLists);
export default __webpack_public_path__ + "static/media/lists.98a3310cd176d97afdf8a3b94c39a778.svg";
export { ForwardRef as ReactComponent };